import React, { useEffect, useRef, useState } from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import * as styles from './tag.module.css';
import { navigate } from 'gatsby';

const Tags = ({
  EmbeddedCasestudyVideoListing = [],
  videoTags = [],
  onTagClick,
  activeTags = [],
}) => {
  const tagRefs = useRef({});
  const scrollbarsRef = useRef(null); // Object to store refs for each tag
  const [selectedTags, setSelectedTags] = useState(activeTags);

  useEffect(() => {
    const handleWheel = event => {
      if (scrollbarsRef.current) {
        if (event.deltaX !== 0) {
          // Allow horizontal scrolling
          event.preventDefault();
          scrollbarsRef.current.view.scrollLeft += event.deltaX;
        } else {
          // Prevent vertical scrolling
          event.preventDefault();
          scrollbarsRef.current.view.scrollLeft += event.deltaY;
        }
      }
    };

    if (scrollbarsRef.current) {
      // Attach the wheel event listener to the scrollbar's view
      const scrollbarView = scrollbarsRef.current.view;
      scrollbarView.addEventListener('wheel', handleWheel);

      return () => {
        scrollbarView.removeEventListener('wheel', handleWheel);
      };
    }
  }, []);

  useEffect(() => {
    const getQueryParameters = name => {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name)?.split(',') || [];
    };

    const tagsFromQuery = getQueryParameters('tags');
    if (tagsFromQuery.length > 0) {
      setSelectedTags(tagsFromQuery.map(tag => tag.toLowerCase()));
    } else {
      setSelectedTags(activeTags);
    }
  }, [activeTags]);

  useEffect(() => {
    selectedTags.forEach(tag => {
      if (tag && tagRefs.current[tag]) {
        tagRefs.current[tag].scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
        });
      }
    });
  }, [selectedTags]);

  const allTags = Array.from(
    new Set(videoTags.map(tag => tag.trim().toLowerCase()).filter(tag => tag))
  );

  const handleTagClick = tag => {
    const normalizedTag = tag.toLowerCase();
    const isTagSelected = selectedTags.includes(normalizedTag);
    const newSelectedTags = isTagSelected
      ? selectedTags.filter(t => t !== normalizedTag)
      : [...selectedTags, normalizedTag];

    setSelectedTags(newSelectedTags);
    onTagClick(newSelectedTags);

    const queryParameters =
      newSelectedTags.length > 0
        ? `?tags=${encodeURIComponent(newSelectedTags.join(','))}`
        : '';

    navigate(`/case-study/${queryParameters}`);
  };

  const renderScrollBarThumb = ({ style, ...props }) => {
    const thumbStyle = {
      backgroundColor: 'gray',
      borderRadius: '2px',
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  };

  const tagsDisplay = allTags.map((normalizedTag, index) => {
    const originalTag = videoTags.find(
      tag => tag.trim().toLowerCase() === normalizedTag
    );

    const isActive = selectedTags.includes(normalizedTag);

    const tagClass = isActive
      ? `${styles.tag} ${styles.activeTags}`
      : styles.tag;

    return (
      <div
        key={index}
        ref={el => (tagRefs.current[normalizedTag] = el)} // Assign ref to the tag element
        className={tagClass} // Apply the correct class based on active status
        onClick={() => handleTagClick(originalTag)}
      >
        {originalTag}
      </div>
    );
  });

  return (
    <div className={styles.tagsContainer}>
      <Scrollbars
        ref={scrollbarsRef}
        autoHide
        autoHideTimeout={1000}
        autoHideDuration={200}
        renderThumbHorizontal={renderScrollBarThumb}
        style={{ width: '100%', height: '100%' }}
      >
        <div className={styles.tagsList}>
          {tagsDisplay.length > 0 ? tagsDisplay : 'No tags'}
        </div>
      </Scrollbars>
    </div>
  );
};

export default Tags;
